module.exports = __webpack_public_path__ + "static/media/Matrix.c55f44c9.svg";